import { useAction, useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useState } from 'react'

import { TradingPositionListItem } from '@root/entities/position/ui'
import { TradingPositionListItemSkeleton } from '@root/entities/position/ui/trading-position-list-item/trading-position-list-item-skeleton'
import { tradingPositionsModelAtom } from '@root/screens/trading'
import { useTranslation } from '@root/shared/localization'
import { TradingList } from '@root/shared/trading'
import { TradePositionDrawer } from '@root/widgets/trade/trade-position-drawer'

import type { AggregatedPositionModel } from '@root/entities/position'

type Props = {}

// TODO: Double check from what wallets we want to show positions
export const TradingPositionsList: React.FC<Props> = () => {
  const { t } = useTranslation()

  const [positionsAtom] = useAtom(tradingPositionsModelAtom)
  const [positionsState] = useAtom(positionsAtom)
  const [loadMoreState] = useAtom(positionsAtom.loadMoreState)

  const [hasMoreItems] = useAtom(positionsAtom.hasMoreItems)
  const loadMore = useAction(positionsAtom.loadMore)

  const [activePosition, setActivePosition] = useState<
    AggregatedPositionModel | undefined
  >()

  const retry = useAction(positionsAtom.load)

  return (
    <>
      <TradingList<AggregatedPositionModel>
        loadMoreState={loadMoreState}
        onLoadMore={loadMore}
        hasMore={hasMoreItems}
        state={positionsState}
        getKey={(it) => it.pairAddress}
        emptyTitle={t('trading.positions.no-positions.title')}
        emptyText={t('trading.positions.no-positions.sub-title')}
        renderItem={(it) => (
          <TradingPositionListItem
            position={it}
            key={it.pair.address}
            onClick={() => {
              setActivePosition(it)
            }}
          />
        )}
        renderSkeleton={() => <TradingPositionListItemSkeleton />}
        onRetry={retry}
      />
      <AnimatePresence>
        {activePosition ? (
          <TradePositionDrawer
            onOpenChange={() => {
              setActivePosition(undefined)
            }}
            open={true}
            position={activePosition}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
